module.exports = __webpack_public_path__ + "static/media/manage_departments_final_product.04fdd65f.mov";